import React, { useEffect, useRef, useState } from "react";

import Modal from "react-bootstrap/Modal";
import AddProduct from "../../addProduct/addproduct";
import "./ozonModal.css";
import "./ozonModalDark.css";
import AddProductOzon from "../addProductOzon/addProdcutOzon";
import { Button, ButtonGroup } from "@chakra-ui/react";
import axios from "axios";
import TagInputOzon from "../tagInputOzon/tagInputOzon";
import SelectOzon from "../SelectOzon/selectOzon";
import ImputOzon from "../inputOzon/inputOzon";
import { Steps } from 'rsuite';
import { Textarea } from '@chakra-ui/react'
import { Checkbox, CheckboxGroup } from '@chakra-ui/react'
import TextAreaOzon from "../ozonTextArea/ozonTextArea";
import { Outlet,useNavigate } from "react-router";
import { Spinner } from '@chakra-ui/react'
import Productinfo from "../productinfo/productinfo";
import sendozon from "../sendozon.json"
import UploadimgOzon from "../uploadimgOzon/uploadozonimg";
import { useToast } from '@chakra-ui/react'
import CheckedBool from "../checkedBool/checkedBool";

import { useDispatch, useSelector } from "react-redux";
export default function OzonModal() {
  
  const toast = useToast()
  const [show, setShow] = useState(false);
  const [isdisable, setisdisable] = useState(true);
  const [category_id, setCategory_ID] = useState(null);
  const [step, setStep] = useState(1);
  const [data, setData] = useState([]);
  const [loading,setLoading]=useState(false)
  const [loadingserver,setLoadingServer]=useState(false)
  const [files, setFiles] = useState([]);
  const modalRef = useRef(null)
  const getDarkModoe = useSelector(darkModes => darkModes )
let prodinfo = useRef()
let caharcters = useRef()
let media = useRef()
let Preview = useRef()



  const handleClose = () => {
    setShow(false)
    setData([])
  };


  const handleShow = () => {
    setShow(true)
   
  };

  const getatribut = (e) => {
    setData([])
    setLoading(true)
    axios({
      method: "get",
      url: `/getatribute/ozon/api?catigory_id=${e}`,
    }).then(function (response) {
  
      setData(response.data.data.result[0]);
      setLoading(false)
      setisdisable(false)
  
    }).catch(error=>{
       
      setLoading(false)
      toast({
        position:"top",
        title: 'Ошибка',
        description: error.response.data.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    })
  };


  const hide=(e)=>{
     if (e == 1) {
      Preview.current.style.display = 'none';
      prodinfo.current.style.display = 'block';
      media.current.style.display = 'none';
     }else if (e == 2) {
      prodinfo.current.style.display = 'none';
      Preview.current.style.display = 'block';
      media.current.style.display = 'none';

     }
     else if (e == 3) {
      prodinfo.current.style.display = 'none';
      Preview.current.style.display = 'none';
      media.current.style.display = 'block';

     }
   
  }

const sendserver=async(e)=>{
    
  setLoadingServer(true)
  e.preventDefault()
  sendozon.items[0].attributes = await []
  sendozon.items[0].category_id = Number(category_id);

  // taginput
  let arr =[]
let myarray = Array.from(e.target.taginput)

  
    for(var i = 0; i < myarray.length; i++) arr.push(myarray[i]);
    
  
    for(var i = 0; i < arr.length; i++) {
        if (JSON.parse(arr[i].value).values.length > 0) {
       
            sendozon.items[0].attributes.push(JSON.parse(arr[i].value))
        }
      
     
    };
 // taginput

//  ====================================================
 // selectsozon
 let arrselectsozon =[]
let selectsozon= Array.from(e.target.selectsozon)

for(var i = 0; i < selectsozon.length; i++) arrselectsozon.push(selectsozon[i]);
for(var i = 0; i < arrselectsozon.length; i++) {
    if (JSON.parse(arrselectsozon[i].value).length > 0) {
      
         sendozon.items[0].attributes.push(JSON.parse(arrselectsozon[i].value)[0])
    }
};
    // selectsozon
    // =======================================

  let inputOzonArray = []
let inputOzonOption = Array.from(e.target.inputOzon)

for(var i = 0; i < inputOzonOption.length; i++) inputOzonArray.push(inputOzonOption[i]);
  for (let i = 0; i < inputOzonArray.length; i++) {
      if (JSON.parse(inputOzonArray[i].value).length > 0) {
      
         sendozon.items[0].attributes.push(JSON.parse(inputOzonArray[i].value)[0])
       
      }
  
  
    
  }
  //  =========================================================================


  // textarea====

  let textAreaArray = []
  let textAreaArrayCollection = Array.from(e.target.TextareaOzon)
  for(var i = 0; i < textAreaArrayCollection.length; i++) textAreaArray.push(textAreaArrayCollection[i]);
    for (let i = 0; i < textAreaArray.length; i++) {
            if (JSON.parse(textAreaArray[i].value).length > 0) {
             
              sendozon.items[0].attributes.push(JSON.parse(textAreaArray[i].value)[0])
            }
    
    }


// ==============================================







let boolCollection = Array.from(e.target.boolvalue)
    for (let i = 0; i < boolCollection.length; i++) {
      
        sendozon.items[0].attributes.push(JSON.parse( boolCollection[i].value))
      
    }

// ===================


console.log(sendozon.items[0].attributes);

    sendozon.items[0].name = e.target.prodname.value
    sendozon.items[0].barcode = e.target.strixkode.value
    sendozon.items[0].offer_id = e.target.arcticul.value
    sendozon.items[0].price = e.target.pirce.value
    sendozon.items[0].old_price = e.target.skidprice.value
    sendozon.items[0].vat = e.target.nds.value
    sendozon.items[0].weight = Number( e.target.wigthprod.value)
    sendozon.items[0].depth = Number(e.target.dlinaprod.value)
    sendozon.items[0].width = Number(e.target.shirinaprod.value)
    sendozon.items[0].height = Number(e.target.visota.value)
    setStep(2)
    hide(2)

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('images', file);
    });
    formData.append('name', JSON.stringify(sendozon));
    axios.post('/ozon/upload/api', formData).then((response) => {
    
      toast({
        position:"top",
        title: 'Отлично',
        description:response.data.message,
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      setLoadingServer(false)
    }).catch(error=>{
      toast({
        position:"top-left",
        title: 'Ошибка',
        description: "We've created your account for you.",
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      setLoadingServer(false)
    })

}

useEffect(()=>{
  modalRef.current.style.display = "none"
},[])
const handleShowModal=()=>{
  modalRef.current.style.display = "flex"
}

const handleCloseModal=()=>{
  modalRef.current.style.display = "none"
}

  return (
    <div className="addProdcutBtnWbCont">
      
      <Button
        variant="primary"
        onClick={handleShowModal}
        className="addProdcutBtnWb"
      >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M5.71127 11.5649H2.70403C2.60433 11.5649 2.50872 11.6045 2.43823 11.675C2.36773 11.7455 2.32812 11.8411 2.32813 11.9408C2.32812 12.0405 2.36773 12.1361 2.43823 12.2066C2.50872 12.2771 2.60433 12.3167 2.70403 12.3167H5.71127C5.81097 12.3167 5.90658 12.2771 5.97708 12.2066C6.04758 12.1361 6.08718 12.0405 6.08718 11.9408C6.08718 11.8411 6.04758 11.7455 5.97708 11.675C5.90658 11.6045 5.81097 11.5649 5.71127 11.5649ZM5.71127 10.0613H2.70403C2.60433 10.0613 2.50872 10.1009 2.43823 10.1714C2.36773 10.2419 2.32813 10.3375 2.32813 10.4372C2.32812 10.5369 2.36773 10.6325 2.43823 10.703C2.50872 10.7735 2.60433 10.8131 2.70403 10.8131H5.71127C5.81097 10.8131 5.90658 10.7735 5.97708 10.703C6.04758 10.6325 6.08718 10.5369 6.08718 10.4372C6.08718 10.3375 6.04758 10.2419 5.97708 10.1714C5.90658 10.1009 5.81097 10.0613 5.71127 10.0613Z" fill="white"/>
  <path d="M12.3698 0.180176H1.62961C1.24521 0.180631 0.876676 0.333536 0.604862 0.60535C0.333047 0.877165 0.180142 1.24569 0.179688 1.6301V3.13372C0.179688 3.23342 0.219292 3.32903 0.289788 3.39952C0.360284 3.47002 0.455897 3.50962 0.555593 3.50962H0.824097V12.5851C0.824495 12.9125 0.954751 13.2264 1.18629 13.458C1.41784 13.6895 1.73176 13.8198 2.05922 13.8202H11.9402C12.2676 13.8198 12.5815 13.6895 12.8131 13.458C13.0446 13.2264 13.1749 12.9125 13.1753 12.5851V3.50962H13.4438C13.5435 3.50962 13.6391 3.47002 13.7096 3.39952C13.7801 3.32903 13.8197 3.23342 13.8197 3.13372V1.6301C13.8192 1.24569 13.6663 0.877165 13.3945 0.60535C13.1227 0.333536 12.7542 0.180631 12.3698 0.180176ZM5.22756 0.931987H8.77181V2.75781H5.22756V0.931987ZM7.9126 3.50962V6.72738L7.20826 6.25782C7.1465 6.21663 7.07393 6.19464 6.99969 6.19464C6.92545 6.19464 6.85288 6.21663 6.79111 6.25782L6.08677 6.72738V3.50962H7.9126ZM0.931499 2.75781V1.6301C0.931726 1.44502 1.00535 1.26758 1.13622 1.13671C1.26709 1.00584 1.44453 0.932214 1.62961 0.931987H4.47575V2.75781H0.931499ZM12.4235 12.5851C12.4233 12.7132 12.3723 12.836 12.2817 12.9266C12.1911 13.0172 12.0683 13.0682 11.9402 13.0684H2.05922C1.93109 13.0682 1.80825 13.0172 1.71765 12.9266C1.62705 12.836 1.57608 12.7132 1.57591 12.5851V3.50962H5.33496V7.42978C5.33496 7.49783 5.35343 7.5646 5.38839 7.62297C5.42336 7.68135 5.47352 7.72914 5.53352 7.76124C5.59351 7.79334 5.6611 7.80856 5.72907 7.80527C5.79703 7.80197 5.86283 7.78029 5.91944 7.74254L6.99969 7.02166L8.07993 7.74168C8.13648 7.77939 8.2022 7.80107 8.27009 7.8044C8.33799 7.80773 8.40551 7.79259 8.46548 7.76059C8.52545 7.72858 8.57562 7.68092 8.61065 7.62267C8.64568 7.56442 8.66426 7.49776 8.66441 7.42978V3.50962H12.4235V12.5851ZM13.0679 2.75781H9.52363V0.931987H12.3698C12.5548 0.932214 12.7323 1.00584 12.8632 1.13671C12.994 1.26758 13.0676 1.44502 13.0679 1.6301V2.75781Z" fill="white"/>
                            </svg>
        <span style={{ marginRight: "10px" }}> Добавить товар</span>
        {/* <span className="material-symbols-outlined">add_box</span> */}

      </Button>
      <div action="">

      <div id="myModal"  className={getDarkModoe.ToggleDarkModeReducer.chekced?"modalForOzonDark":"modalForOzon"} ref={modalRef}>


                  <div className="modal-contentOzon">
                    <div className="modal-headerOzon">
                      {/* <span className="closeOzon" onClick={handleCloseModal}>&times;</span> */}
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34" fill="none" className="closeOzon" onClick={handleCloseModal}>
  <path d="M3.26872 33.9823C2.42336 34.0313 1.59194 33.751 0.949784 33.2004C-0.316595 31.9297 -0.316595 29.8773 0.949784 28.6066L28.6793 0.946278C29.9965 -0.28314 32.0633 -0.214797 33.2958 1.09906C34.4103 2.28717 34.4753 4.11332 33.4479 5.37718L5.55496 33.2004C4.92115 33.743 4.103 34.0229 3.26872 33.9823Z" fill="#3B79F6"/>
  <path d="M30.9654 33.9824C30.1086 33.9788 29.2875 33.6395 28.6791 33.0376L0.949424 5.37719C-0.223811 4.01055 -0.0643033 1.95383 1.30576 0.78342C2.52858 -0.26114 4.33199 -0.26114 5.5547 0.78342L33.4476 28.4438C34.7645 29.6735 34.8325 31.7353 33.5997 33.0488C33.5507 33.101 33.5 33.1516 33.4476 33.2005C33.1097 33.4936 32.715 33.7142 32.288 33.8488C31.861 33.9833 31.4108 34.0288 30.9654 33.9824Z" fill="#3B79F6"/>
</svg> */}
                    
                    </div>
                    <div className="modal-bodyOzon">
                  
                              <div className="stepCont">
        
                            {/* <Steps current={step}>
                                <Steps.Item title="Информация о товаре" onClick={()=> [setStep(1),hide(1)]} />
                                <Steps.Item title="Характеристики" onClick={()=> [setStep(2),hide(2)]} />
                                <Steps.Item title="Медиа"onClick={()=> [setStep(3),hide(3)]}/>
                            </Steps> */}
                        
                               <div   onClick={()=> [setStep(1),hide(1)]}>
                                
                                
                               <svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" viewBox="0 0 43 42" fill="none">
  <g clip-path="url(#clip0_2205_3923)">
    <path d="M21.5 42C33.098 42 42.5 32.598 42.5 21C42.5 9.40202 33.098 0 21.5 0C9.90202 0 0.5 9.40202 0.5 21C0.5 32.598 9.90202 42 21.5 42Z" fill="#F5F5F5"/>
    <path d="M22.6191 13.7031V28H20.8125V15.959L17.1699 17.2871V15.6562L22.3359 13.7031H22.6191Z" fill="#3B79F6"/>
  </g>
  <defs>
    <clipPath id="clip0_2205_3923">
      <rect width="43" height="42" fill="white"/>
    </clipPath>
  </defs>
</svg>
                                        <p>Информация о товаре</p>
                                      
                              </div>
                              <span></span>
                              <div onClick={()=> [setStep(2),hide(2)]} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <g clip-path="url(#clip0_2207_3935)">
          <path d="M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z" fill="#F5F5F5"/>
          <path d="M25.498 26.5156V28H16.1914V26.7012L20.8496 21.5156C21.4225 20.8776 21.8652 20.3372 22.1777 19.8945C22.4967 19.4453 22.7181 19.0449 22.8418 18.6934C22.972 18.3353 23.0371 17.9707 23.0371 17.5996C23.0371 17.1309 22.9395 16.7077 22.7441 16.3301C22.5553 15.946 22.2754 15.64 21.9043 15.4121C21.5332 15.1842 21.084 15.0703 20.5566 15.0703C19.9251 15.0703 19.3978 15.194 18.9746 15.4414C18.5579 15.6823 18.2454 16.0208 18.0371 16.457C17.8288 16.8932 17.7246 17.3945 17.7246 17.9609H15.918C15.918 17.1602 16.0938 16.4277 16.4453 15.7637C16.7969 15.0996 17.3177 14.5723 18.0078 14.1816C18.6979 13.7845 19.5475 13.5859 20.5566 13.5859C21.4551 13.5859 22.2233 13.7454 22.8613 14.0645C23.4993 14.377 23.9876 14.8197 24.3262 15.3926C24.6712 15.959 24.8438 16.623 24.8438 17.3848C24.8438 17.8014 24.7721 18.2246 24.6289 18.6543C24.4922 19.0775 24.3001 19.5007 24.0527 19.9238C23.8118 20.347 23.5286 20.7637 23.2031 21.1738C22.8841 21.584 22.5423 21.9876 22.1777 22.3848L18.3691 26.5156H25.498Z" fill="#3B79F6"/>
        </g>
        <defs>
          <clipPath id="clip0_2207_3935">
            <rect width="42" height="42" fill="white"/>
          </clipPath>
        </defs>
                                    </svg>
                                <p>Характеристики</p>
                                     
                              </div>
                              <span></span>
                              <div  onClick={()=> [setStep(3),hide(3)]}>
                             
                                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
      <g clip-path="url(#clip0_2207_3926)">
        <path d="M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z" fill="#F5F5F5"/>
        <path d="M18.8184 20.002H20.1074C20.7389 20.002 21.2598 19.8978 21.6699 19.6895C22.0866 19.4746 22.3958 19.1849 22.5977 18.8203C22.806 18.4492 22.9102 18.0326 22.9102 17.5703C22.9102 17.0234 22.819 16.5645 22.6367 16.1934C22.4544 15.8223 22.181 15.5423 21.8164 15.3535C21.4518 15.1647 20.9896 15.0703 20.4297 15.0703C19.9219 15.0703 19.4727 15.1712 19.082 15.373C18.6979 15.5684 18.3952 15.8483 18.1738 16.2129C17.959 16.5775 17.8516 17.0072 17.8516 17.502H16.0449C16.0449 16.7793 16.2272 16.1217 16.5918 15.5293C16.9564 14.9368 17.4674 14.4648 18.125 14.1133C18.7891 13.7617 19.5573 13.5859 20.4297 13.5859C21.2891 13.5859 22.041 13.7389 22.6855 14.0449C23.3301 14.3444 23.8314 14.7936 24.1895 15.3926C24.5475 15.985 24.7266 16.724 24.7266 17.6094C24.7266 17.9674 24.6419 18.3516 24.4727 18.7617C24.3099 19.1654 24.0527 19.543 23.7012 19.8945C23.3561 20.2461 22.9069 20.5358 22.3535 20.7637C21.8001 20.985 21.1361 21.0957 20.3613 21.0957H18.8184V20.002ZM18.8184 21.4863V20.4023H20.3613C21.2663 20.4023 22.015 20.5098 22.6074 20.7246C23.1999 20.9395 23.6654 21.2259 24.0039 21.584C24.349 21.9421 24.5898 22.3359 24.7266 22.7656C24.8698 23.1888 24.9414 23.612 24.9414 24.0352C24.9414 24.6992 24.8275 25.2884 24.5996 25.8027C24.3783 26.3171 24.0625 26.7533 23.6523 27.1113C23.2487 27.4694 22.7734 27.7396 22.2266 27.9219C21.6797 28.1042 21.084 28.1953 20.4395 28.1953C19.821 28.1953 19.2383 28.1074 18.6914 27.9316C18.151 27.7559 17.6725 27.502 17.2559 27.1699C16.8392 26.8314 16.5137 26.418 16.2793 25.9297C16.0449 25.4349 15.9277 24.8717 15.9277 24.2402H17.7344C17.7344 24.735 17.8418 25.168 18.0566 25.5391C18.278 25.9102 18.5905 26.1999 18.9941 26.4082C19.4043 26.61 19.8861 26.7109 20.4395 26.7109C20.9928 26.7109 21.4681 26.6165 21.8652 26.4277C22.2689 26.2324 22.5781 25.9395 22.793 25.5488C23.0143 25.1582 23.125 24.6667 23.125 24.0742C23.125 23.4818 23.0013 22.9967 22.7539 22.6191C22.5065 22.235 22.1549 21.9518 21.6992 21.7695C21.25 21.5807 20.7194 21.4863 20.1074 21.4863H18.8184Z" fill="#3B79F6"/>
      </g>
      <defs>
        <clipPath id="clip0_2207_3926">
          <rect width="42" height="42" fill="white"/>
        </clipPath>
      </defs>
                                  </svg>
                               <p>Медиа</p>
                                       
                              </div>
                            
                            </div>
                          
                          <form className="formAllOzon" id="form" onSubmit={sendserver}>
                          <div >
                            {
                              loading?
                              <Spinner />
                              :
                            ""
                            }
                            <div className="OptionsContOzon">
                                
                                <AddProductOzon
                                  setisdisable={setisdisable}
                                  setCategory_ID={setCategory_ID}
                                  getatribut={getatribut}
                                />
                              </div>
                            
                              <div className="inputsConbtOzon" ref={Preview}>
                                {data.attributes?.map((item, index) => {
                                    
                                  if (item.is_collection == true && item.type !== "multiline") {
                      
                                    return (
                                      <TagInputOzon childs={item.childs.result} item={item} key={index} required={item.is_required}/>
                                    );
                                  } 
                                  
                                  else if (item.childs.code !== 3 && item.is_collection == false && item.type !== "multiline") {
                                    return (
                                    <SelectOzon childs={item.childs.result} item={item} key={index}/>
                                    );
                                  } 
                                  else if (item.type == "multiline") {
                                    return (
                                  
                                  <TextAreaOzon  placeholder={item.name} item={item} key={index}/>
                                    );
                                  } 

                                  else if (item.type == "Boolean") {
                                    return (
                                  
                                    
                                      <CheckedBool item={item} key={index}/>
                                    );
                                  } 
                                  else {
                                    return (
                                      <div key={index}>
                                        <ImputOzon type={"number"}  childs={item.childs.result} item={item} key={index} />
                                      </div>
                                    );
                                  }
                                })}
                              </div>
                              <div ref={prodinfo}>
                              <Productinfo   />
                              </div>
                              <div ref={media} className="media">
                                <UploadimgOzon jsondata={sendozon} setFiles={setFiles} files={files}/>
                            </div>
                            </div>
                            <div className="modalFooter">
                            <button variant="secondary" className="closeModalOzon" onClick={handleCloseModal}>
                              Закрыть
                              </button>
                                {loadingserver?
                                <Button
                                isLoading
                                loadingText='Submitting'
                                colorScheme='blue'
                                variant='outline'
                              >
                                Submit
                              </Button>
                                :
                                <button
                                colorScheme="blue"
                               className="creatProductOz"
                                isDisabled={isdisable}
                                type="submit"
                              >
                                Создать товар
                              </button>
                                }
                            
                          
                            </div>
                          </form>
                    </div>

                  </div>

      </div>

        
        {/* <Modal show={show} onHide={handleClose} fullscreen={true}>
          <Modal.Header closeButton>
            <Modal.Title>Добавить новый товар</Modal.Title>
           
          </Modal.Header>
          <Modal.Body className="modalbody">
          <div className="stepCont">
          <Steps current={step}>
              <Steps.Item title="Информация о товаре" onClick={()=> [setStep(1),hide(1)]} />
              <Steps.Item title="Характеристики" onClick={()=> [setStep(2),hide(2)]} />
              <Steps.Item title="Медиа"onClick={()=> [setStep(3),hide(3)]}/>
           </Steps>
          </div>
        <form className="formAllOzon" id="form" onSubmit={sendserver}>
        <div >
          {
            loading?
            <Spinner />
            :
           ""
          }
           <div className="OptionsContOzon">
              
              <AddProductOzon
                setisdisable={setisdisable}
                setCategory_ID={setCategory_ID}
                getatribut={getatribut}
              />
            </div>
           
            <div className="inputsConbtOzon" ref={Preview}>
              {data.attributes?.map((item, index) => {
                  
                if (item.is_collection == true && item.type !== "multiline") {
     
                  return (
                    <TagInputOzon childs={item.childs.result} item={item} key={index} required={item.is_required}/>
                  );
                } 
                
                else if (item.childs.code !== 3 && item.is_collection == false && item.type !== "multiline") {
                  return (
                  <SelectOzon childs={item.childs.result} item={item} key={index}/>
                  );
                } 
                else if (item.type == "multiline") {
                  return (
                
                 <TextAreaOzon  placeholder={item.name} item={item} key={index}/>
                  );
                } 

                else if (item.type == "Boolean") {
                  return (
                
                   
                    <CheckedBool item={item} key={index}/>
                  );
                } 
                else {
                  return (
                    <div key={index}>
                      <ImputOzon type={"number"}  childs={item.childs.result} item={item} key={index} />
                    </div>
                  );
                }
              })}
            </div>
            <div ref={prodinfo}>
            <Productinfo   />
            </div>
            <div ref={media} className="media">
               <UploadimgOzon jsondata={sendozon} setFiles={setFiles} files={files}/>
           </div>
          </div>
          <div className="modalFooter">
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
            Закрыть
            </Button>
              {loadingserver?
               <Button
               isLoading
               loadingText='Submitting'
               colorScheme='blue'
               variant='outline'
             >
               Submit
             </Button>
              :
              <Button
              colorScheme="blue"
             
              isDisabled={isdisable}
              type="submit"
            >
              Создать товар
            </Button>
              }
           
         
          </Modal.Footer>
          </div>
        </form>
         
          
          
          </Modal.Body>
         
        </Modal> */}
      </div>
    </div>
  );
}
